module.exports = __webpack_public_path__ + "img/infoline.3b583220.svg";